import { render, staticRenderFns } from "./ProductReturn.vue?vue&type=template&id=c2440e20&scoped=true&"
import script from "./ProductReturn.vue?vue&type=script&lang=js&"
export * from "./ProductReturn.vue?vue&type=script&lang=js&"
import style0 from "./ProductReturn.vue?vue&type=style&index=0&id=c2440e20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2440e20",
  null
  
)

export default component.exports